import React, { useState } from 'react'

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: '#fff',
    padding: '32px',
    maxWidth: '400px',
    width: '100%',
    border: '2px solid var(--color-border)',
  },
  title: {
    marginTop: 0,
    marginBottom: '8px',
  },
  subtitle: {
    color: 'var(--color-muted)',
    marginBottom: '24px',
  },
  field: {
    marginBottom: '24px',
  },
  label: {
    display: 'block',
    fontWeight: '600',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '12px',
    border: '2px solid var(--color-border)',
    fontSize: '1rem',
  },
  btn: {
    width: '100%',
    padding: '14px 24px',
    border: '2px solid var(--color-border)',
    background: 'var(--color-primary)',
    color: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  hint: {
    fontSize: '0.875rem',
    color: 'var(--color-muted)',
    marginTop: '8px',
  },
}

export default function NameModal({ puzzleTheme, onStart }) {
  const [name, setName] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    onStart(name.trim() || 'Anonymous')
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Ready to solve?</h2>
        <p style={styles.subtitle}>{puzzleTheme || 'Crossword Puzzle'}</p>

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Your Name</label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter your name..."
              style={styles.input}
              autoFocus
            />
            <p style={styles.hint}>
              Your name will appear on the leaderboard when you complete the puzzle.
            </p>
          </div>

          <button type="submit" style={styles.btn}>
            Start Solving
          </button>
        </form>
      </div>
    </div>
  )
}
